export const ENGLISH_IQ_DAILY_TARGET_MINUTES = [5, 10, 15] as const;

export type EnglishIqDailyTargetMinutesType = (typeof ENGLISH_IQ_DAILY_TARGET_MINUTES)[number];
